import { IoChevronDownCircleSharp } from 'react-icons/io5'
import { BsInputCursor, BsCalendarDate, BsFillImageFill } from 'react-icons/bs'
import { BiTimeFive, BiRadioCircleMarked } from 'react-icons/bi'
import { TbSortAscendingNumbers } from 'react-icons/tb'
import { MdGpsFixed } from 'react-icons/md'
import { IoIosArrowDropdownCircle } from 'react-icons/io'

const INPUTTYPES = {
    text: {
        name: "Text",
        icon: <BsInputCursor />
    },
    // date: {
    //     name: "Date",
    //     icon: <BsCalendarDate />
    // },
    // time: {
    //     name: "Time",
    //     icon: <BiTimeFive />
    // },
    number: {
        name: "Number",
        icon: <TbSortAscendingNumbers />
    },
    image: {
        name: "Image",
        icon: <BsFillImageFill />
    },
    gps: {
        name: "GPS",
        icon: <MdGpsFixed />

    },
    // dropdown: {
    //     name: "Dropdown",
    //     icon: <IoIosArrowDropdownCircle />
    // },
    radio: {
        name: "Radio",
        icon: <BiRadioCircleMarked />
    },
    checkbox: {
        name: "Checkbox",
        icon: <BiRadioCircleMarked />
    },
}

export default INPUTTYPES;